import axios from 'axios'
import setupAxios from './SetupAxios'
import store from '../redux/Store'
import { getApiBaseUrl } from '../apiBaseUrl'

const axiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
})

// Setup interceptors
setupAxios(axiosInstance, store)

export default axiosInstance 